// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"442":"69cafd7f","787":"8b852a39"}[chunkId] + ".chunk.js";
};